/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { THREEVectorAndColor } from './InteractiveComponents';
export const metadata = {
  demo: THREEVectorAndColor,
  title: 'THREE.Vector & THREE.Color'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ThreeJS uses a data types for "coordinates" called `}<inlineCode parentName="p">{`THREE.Vector`}</inlineCode>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/math/Vector2"
        }}>{`THREE.Vector2`}</a>{` (2D Coordinate)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/math/Vector3"
        }}>{`THREE.Vector3`}</a>{` (3D Coordinate)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/math/Vector4"
        }}>{`THREE.Vector4`}</a>{` (4D Coordinate)`}</li>
    </ul>
    <p>{`It also uses a data type for colors called `}<inlineCode parentName="p">{`THREE.Color`}</inlineCode>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/#api/en/math/Color"
        }}>{`THREE.Color`}</a></li>
    </ul>
    <p>{`Here's one of our earlier demos but using ThreeJS data types instead of plain JavaScript objects.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
